/**
 * WEB-3956 юнит 8 — обёртки ожидания маршрутов (были в `router/index.tsx`).
 *
 * WEB-3739 юнит 3 (кит фронтендера README «Загрузка страницы при переходе»,
 * эталон app.jsx `pgLoad`): пока догружается код страницы — капля кита, а не
 * кольцо. Внутри кабинета меню и плашки стоят, капля — по центру окна
 * (`CabinetSuspense`); на входе, в документах и витринах шапки ещё нет (она
 * живёт внутри ленивой страницы) — пустой экран с фоном темы
 * (`FirstSuspense`). Админ-панель, свой домен клиента, публичный плеер и
 * приглашение — прежний `SuspenseWrap` с `Preloader`.
 */
import React, { Suspense } from 'react';
import { Preloader } from '@/components/kit';
import { PageLoading } from '@/components/kit/ds';

export const Fallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <Preloader />
  </div>
);

export function SuspenseWrap({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<Fallback />}>{children}</Suspense>;
}

export function CabinetSuspense({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
}

export function FirstSuspense({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoading first />}>{children}</Suspense>;
}
